export default function AccessDenied({
  title = 'Access restricted',
  message = 'You do not have permission to view this section.',
  note,
  variant = 'default',
}) {
  const className = variant === 'compact'
    ? 'access-denied access-denied-compact'
    : 'access-denied';

  return (
    <section className={className} role="alert">
      <div className="access-denied-copy">
        <h2>{title}</h2>
        <p>
          {message}
          {note ? <span className="access-denied-note"> {note}</span> : null}
        </p>
      </div>
    </section>
  );
}
